import { render, staticRenderFns } from "./DiscountRules.vue?vue&type=template&id=bb099540&"
import script from "./DiscountRules.vue?vue&type=script&lang=js&"
export * from "./DiscountRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports